import { useQuery } from "@tanstack/react-query";
import { getSeasonBanner } from "./rest/seasonBanner";
import { SeasonBanner } from "../types/seasonBanner.interface";

const HIDDEN: SeasonBanner = { show: false };

/**
 * The gateway resolves the whole decision — window, audience and targeting —
 * so the client only renders what it is handed. A failure here must never
 * block the Tax Center: the banner is informational, so an error degrades to
 * "no banner" rather than surfacing to the investor.
 */
const useSeasonBannerQuery = () => {
  const { data, isLoading } = useQuery<SeasonBanner>({
    queryKey: ["season-banner"],
    queryFn: getSeasonBanner,
    retry: false,
    staleTime: 5 * 60 * 1000,
  });

  return { banner: data ?? HIDDEN, isLoading };
};

export default useSeasonBannerQuery;
